import produce from 'immer';
import {
    GET_FIELD_WORK_WINDOW_REQUEST, GET_FIELD_WORK_WINDOW_SUCCESS, GET_FIELD_WORK_WINDOW_FAILURE,
    GET_FIELD_WORK_WINDOW_CANCEL, GET_WORK_WINDOW_CONFIG_REQUEST, GET_WORK_WINDOW_CONFIG_SUCCESS,
    GET_WORK_WINDOW_CONFIG_FAILURE, GET_REGIONS_LIST, SELECT_REGIONS, TOGGLE_WORKWINDOW,
    UPDATE_WORK_WINDOW_CONFIG, CLEAR_FIELD_WORK_WINDOWS, VISIBLE_WORKWINDOW,
    GET_GEO_STORAGE_LOCATION_REQUEST, GET_GEO_STORAGE_LOCATION, GET_GEO_STORAGE_REPORT_REQUEST,
    GET_GEO_STORAGE_REPORT, GET_GEO_FIELD_LIST, GET_GEO_FIELD_LIST_REQUEST, FIELD_LIST_REQUEST_ID,
    GET_GEO_WORKED_ACRES, GET_GEO_WORKED_ACRES_REQUEST, UPDATE_FIELD_WORK_STATUS_SUCCESS, GET_GEO_CROP_LIST,
    GET_REGIONS_DETAIL, GET_REGIONS_DETAIL_REQUEST, GEO_REGION_WORKED_DATE_REQUEST, GEO_REGION_WORKED_DATE, GEO_REGION_WORKED_EG_REQUEST, GEO_REGION_WORKED_EG, TARE_LOAD_CAPACITY,
    GEO_CONFIG,
    GET_LOGISTIC_GEO_STORAGE_REPORT_REQUEST,
    GET_LOGISTIC_GEO_STORAGE_REPORT,
    GEO_FIELD_REPORT_REQUEST,
    GEO_FIELD_REPORT
} from '../constants/action-types';
import { groupBy } from '../helpers/common';
import { Unit } from '../helpers/unit';
import { getAreaOfPolygon } from 'geolib';
import { getWorkedAcres } from '../interceptors/geo';
import { HARVESTING_WORK_TYPE_ID } from '../constants';

const initialState = {
    farmId: null,
    regionsList: [],
    regionsDetails: null,
    isRegionsDetailsRequesting: false,
    selectedRegionIds: null,
    regionRefresh: 0,
    fieldWorkWindowById: {},
    workWindowConfigById: {},
    fieldListById: {
        isRequesting: false,
        payload: {}
    },
    workedAcresById: {
        isRequesting: false,
        payload: {}
    },
    defaultWorkWindowConfig: {
        grid_type: "square",
        min_cell_width_meters: 30,
        min_field_overlap_percent: 75,
        work_window_width_multiplier: 2,
        cell_complete_percent: 25,
        include_grid: true,
        include_work_windows: false
    },
    geoStorageLocations: {
        isRequesting: false,
        requestingShapeIds: [],
        payload: {}
    },
    geoStorageReport: {
        isRequesting: false,
        requestingShapeIds: [],
        payload: {}
    },
    geoLogisticStorageReport: {
        isRequesting: false,
        requestingShapeIds: [],
        payload: {},
        rangeWiseReport: {}
    },
    requestIds: [],
    cropList: [],
    workedDate: {
        isRequesting: false,
        payload: {}
    },
    workedEG: {
        isRequesting: false,
        payload: []
    },
    totalTareCapacity: {
        selectedDateTareTotal: 0,
        totalYearTareTotal: 0,
        totalYearLoadCount: 0,
        totalDateWiseLoadCount: 0
    },
    geo_config: {},
    geoFieldReport: {
        isRequesting: false,
        payload: {}
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_REGIONS_LIST:
            state = {
                ...state, farmId: action.farmId,
                regionsList: [...action.payload],
                selectedRegionIds: (state.farmId === action.farmId) ? state.selectedRegionIds : null,
                regionRefresh: state.regionRefresh + 1
            };
            break;
        case GET_REGIONS_DETAIL_REQUEST:
            state = {
                ...state,
                regionsDetails: null,
                isRegionsDetailsRequesting: true
            };
            break;
        case GET_REGIONS_DETAIL:
            state = {
                ...state,
                regionsDetails: action.payload,
                isRegionsDetailsRequesting: false
            };
            break;
        case GET_FIELD_WORK_WINDOW_REQUEST: {
            const { shapeRefId } = action.payload;
            state = {
                ...state,
                fieldWorkWindowById: {
                    ...state.fieldWorkWindowById,
                    [shapeRefId]: {
                        ...state.fieldWorkWindowById[shapeRefId],
                        ...action.payload, isRequesting: true
                    }
                }
            };
            break;
        }
        case GET_FIELD_WORK_WINDOW_SUCCESS:
        case GET_FIELD_WORK_WINDOW_FAILURE: {
            const { shapeRefId, data } = action.payload;
            state = {
                ...state,
                fieldWorkWindowById: {
                    ...state.fieldWorkWindowById,
                    [shapeRefId]: {
                        ...state.fieldWorkWindowById[shapeRefId],
                        ...data, isRequesting: false
                    }
                }
            };
            break;
        }
        case GET_FIELD_WORK_WINDOW_CANCEL: {
            const { shapeRefId } = action.payload;
            state = {
                ...state,
                fieldWorkWindowById: {
                    ...state.fieldWorkWindowById,
                    [shapeRefId]: {
                        ...state.fieldWorkWindowById[shapeRefId],
                        isRequesting: false, rangeId: 0
                    }
                }
            };
            break;
        }
        case UPDATE_WORK_WINDOW_CONFIG: {
            const { shapeRefId, config } = action.payload;
            state = {
                ...state, fieldWorkWindowById: {
                    ...state.fieldWorkWindowById,
                    [shapeRefId]: { ...state.fieldWorkWindowById[shapeRefId], config }
                }
            };
            break;
        }
        case TOGGLE_WORKWINDOW: {
            const { shapeRefId, toggle } = action.payload;
            state = {
                ...state, fieldWorkWindowById: {
                    ...state.fieldWorkWindowById,
                    [shapeRefId]: { ...state.fieldWorkWindowById[shapeRefId], isWorkWindow: toggle }
                }
            };
            break;
        }
        case VISIBLE_WORKWINDOW: {
            const { shapeRefId, visible } = action.payload;
            state = {
                ...state, fieldWorkWindowById: {
                    ...state.fieldWorkWindowById,
                    [shapeRefId]: { ...state.fieldWorkWindowById[shapeRefId], visible }
                }
            };
            break;
        }
        case CLEAR_FIELD_WORK_WINDOWS:
            state = { ...state, fieldWorkWindowById: initialState.fieldWorkWindowById };
            break;
        case SELECT_REGIONS:
            state = { ...state, selectedRegionIds: action.payload };
            break;
        case GET_WORK_WINDOW_CONFIG_REQUEST: {
            const { farmId } = action.payload;
            state = {
                ...state, workWindowConfigById: {
                    ...state.workWindowConfigById,
                    [farmId]: { isRequesting: true }
                }
            };
            break;
        }
        case GET_WORK_WINDOW_CONFIG_SUCCESS: {
            const { farmId, config } = action.payload;
            state = {
                ...state, workWindowConfigById: {
                    ...state.workWindowConfigById,
                    [farmId]: { isRequesting: false, ...config }
                }
            };
            break;
        }
        case GET_WORK_WINDOW_CONFIG_FAILURE: {
            const { farmId } = action.payload;
            state = {
                ...state, workWindowConfigById: {
                    ...state.workWindowConfigById,
                    [farmId]: { isRequesting: false }
                }
            };
            break;
        }
        case GET_GEO_STORAGE_LOCATION_REQUEST: {
            const regionShapeIds = ((action.payload || {}).geo_region_shape_uuid || '').split(',');
            state = produce(state, s => {
                s.geoStorageLocations.isRequesting = true;
                s.geoStorageLocations.requestingShapeIds = regionShapeIds;
            });
            break;
        }
        case GET_GEO_STORAGE_LOCATION: {
            const { data, geo_region_shape_uuid } = action.payload;
            state = produce(state, s => {
                const geoLocationById = groupBy('geo_region_shape_uuid')(data) || {};
                const geoRegionShapeIds = typeof geo_region_shape_uuid === 'string' ? geo_region_shape_uuid.split(',') : [];

                s.geoStorageLocations.isRequesting = false;
                s.geoStorageLocations.requestingShapeIds = [];
                geoRegionShapeIds.forEach(geoRegionShapeId => {
                    s.geoStorageLocations.payload[geoRegionShapeId] = geoLocationById[geoRegionShapeId] || [];
                });
            });
            break;
        }

        case GET_GEO_STORAGE_REPORT_REQUEST: {
            const regionShapeIds = ((action.payload || {}).geo_region_shape_uuid || '').split(',');
            state = produce(state, s => {
                s.geoStorageReport.isRequesting = true;
                s.geoStorageReport.requestingShapeIds = regionShapeIds;
            });
            break;
        }
        case GET_GEO_STORAGE_REPORT: {
            const { data, geo_region_shape_uuid } = action.payload;
            state = produce(state, s => {
                s.geoStorageReport.isRequesting = false;
                s.geoStorageReport.requestingShapeIds = [];
                s.geoStorageReport.payload[geo_region_shape_uuid] = {
                    storageList: (data.storage_list || []).map(storage => ({
                        geoStorageLocationId: storage.geo_storage_location_uuid,
                        totalCapacity: storage.total_capacity || 0,
                        filledCapacity: storage.filled_capacity || 0,
                        selectedFilledCapacity: storage.selected_range_filled_capacity || 0,
                        availableCapacity: storage.available_capacity || 0,
                        totalLoad: storage.total_load || 0,
                        selectedTotalLoad: storage.total_selected_range_load || 0,
                        tareWeight: data.summary.tare_weight || 0,
                    })),
                    summary: {
                        totalCapacity: data.summary.total_capacity || 0,
                        totalCapacityWithoutUnknown: data.summary.total_loads_without_unknown || 0,
                        filledCapacity: data.summary.filled_capacity || 0,
                        filledCapacityWithoutUnknown: data.summary.filled_capacity_without_unknown || 0,
                        selectedFilledCapacity: data.summary.selected_range_filled_capacity || 0,
                        selectedFilledCapacityWithUnknown: data.summary.selected_range_filled_capacity_without_unknown || 0,
                        availableCapacity: data.summary.available_capacity || 0,
                        tareWeight: data.summary.tare_weight || 0,
                        // loads
                        totalLoads: data.summary.total_loads || 0,
                        totalLoadsWithoutUnknown: data.summary.total_loads_without_unknown || 0,
                        selectedTotalLoads: data.summary.total_selected_range_loads || 0,
                        selectedTotalLoadsWithoutUnknown: data.summary.total_selected_range_loads_without_unknown || 0,
                        load_start_date: data.summary.load_start_date || "",
                        load_end_date: data.summary.load_end_date || ""
                    }
                };
            });
            break;
        }
        case GET_LOGISTIC_GEO_STORAGE_REPORT_REQUEST: {
            const regionShapeIds = ((action.payload || {}).geo_region_shape_uuid || '').split(',');
            state = produce(state, s => {
                s.geoLogisticStorageReport.isRequesting = true;
                s.geoLogisticStorageReport.requestingShapeIds = regionShapeIds;
            });
            break;
        }
        case GET_LOGISTIC_GEO_STORAGE_REPORT: {
            const { data, geo_region_shape_uuid, plan_type_id, range_type } = action.payload;
            state = produce(state, s => {
                s.geoLogisticStorageReport.isRequesting = false;
                s.geoLogisticStorageReport.requestingShapeIds = [];
                if (plan_type_id === 5 && range_type !== "todate") {
                    s.geoLogisticStorageReport.rangeWiseReport[geo_region_shape_uuid] = {
                        storageList: (data.storage_list || []).map(storage => ({
                            geoStorageLocationId: storage.geo_storage_location_uuid,
                            filledCapacity: storage.filled_capacity || 0,
                            selectedFilledCapacity: storage.selected_range_filled_capacity || 0,
                        })),
                        summary: {
                            selectedFilledCapacity: data.summary.selected_range_filled_capacity || 0,
                            selectedFilledCapacityWithUnknown: data.summary.selected_range_filled_capacity_without_unknown || 0,
                        }
                    }
                }
                s.geoLogisticStorageReport.payload[geo_region_shape_uuid] = {
                    storageList: (data.storage_list || []).map(storage => ({
                        geoStorageLocationId: storage.geo_storage_location_uuid,
                        totalCapacity: storage.total_capacity || 0,
                        filledCapacity: storage.filled_capacity || 0,
                        selectedFilledCapacity: storage.selected_range_filled_capacity || 0,
                        availableCapacity: storage.available_capacity || 0,
                        totalLoad: storage.total_load || 0,
                        selectedTotalLoad: storage.total_selected_range_load || 0
                    })),
                    summary: {
                        totalCapacity: data.summary.total_capacity || 0,
                        totalCapacityWithoutUnknown: data.summary.total_loads_without_unknown || 0,
                        filledCapacity: data.summary.filled_capacity || 0,
                        filledCapacityWithoutUnknown: data.summary.filled_capacity_without_unknown || 0,
                        selectedFilledCapacity: data.summary.selected_range_filled_capacity || 0,
                        selectedFilledCapacityWithUnknown: data.summary.selected_range_filled_capacity_without_unknown || 0,
                        availableCapacity: data.summary.available_capacity || 0,
                        // loads
                        totalLoads: data.summary.total_loads || 0,
                        totalLoadsWithoutUnknown: data.summary.total_loads_without_unknown || 0,
                        selectedTotalLoads: data.summary.total_selected_range_loads || 0,
                        selectedTotalLoadsWithoutUnknown: data.summary.total_selected_range_loads_without_unknown || 0,
                        load_start_date: data.summary.load_start_date || "",
                        load_end_date: data.summary.load_end_date || ""
                    }
                };
            });
            break;
        }

        case GEO_FIELD_REPORT_REQUEST: {
            state = {
                ...state,
                geoFieldReport: {
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case GEO_FIELD_REPORT: {
            const { payload } = action;
            const data = payload.data;

            const loadsData = data && data.loads ? data.loads : {};
            const tareData = data && data.tare ? data.tare : {};
            const summaryData = data && data.summary ? data.summary : {};

            const geoFieldReportData = {
                loads: {
                    total_loads: loadsData.total_loads || 0,
                    total_capacity: loadsData.total_capacity || 0,
                    total_gross_weight: loadsData.total_gross_weight || 0,
                    total_light_weight: loadsData.total_light_weight || 0,
                    total_tare_weight: loadsData.total_tare_weight || 0,
                    field_geo_shape_uuid: loadsData.field_geo_shape_uuid || null
                },
                tare: {
                    total_loads: tareData.total_loads || 0,
                    total_capacity: tareData.total_capacity || 0,
                    total_gross_weight: tareData.total_gross_weight || 0,
                    total_light_weight: tareData.total_light_weight || 0
                },
                geo_region_uuid: data && data.geo_region_uuid ? data.geo_region_uuid : null,
                summary: {
                    total_acreage: summaryData.total_acreage || 0,
                    harvested_acreage: summaryData.harvested_acreage || 0,
                    percent_acreage: summaryData.percent_acreage || 0,
                    total_harvested_hectograms: summaryData.total_harvested_hectograms || 0,
                    average_hectograms_per_acre: summaryData.average_hectograms_per_acre || 0,
                    data: summaryData.data || [],
                    today_data: summaryData.today_data || null,
                }
            };

            return {
                ...state,
                geoFieldReport: {
                    isRequesting: false,
                    payload: geoFieldReportData
                }
            };
        }

        case GET_GEO_FIELD_LIST_REQUEST: {
            state = {
                ...state,
                fieldListById: {
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case GET_GEO_FIELD_LIST: {
            const { payload } = action;
            const unit = Unit.getInstance();
            const fieldListById = {};
            if (payload) payload.forEach(item => {
                item.shapes && item.shapes.forEach(e => {
                    const setOfLocation = (e.geo_shape_type === "polygon" && e.location)
                        ? e.location.map(points => [points.lng, points.lat]) : [];
                    const workStatus = Array.isArray(e.work_status)
                        ? e.work_status.filter(x => x.work_type_id === HARVESTING_WORK_TYPE_ID) : [];
                    const lastWorkStatus = workStatus.length > 0
                        ? workStatus[workStatus.length - 1]
                        : {
                            work_type_id: HARVESTING_WORK_TYPE_ID,
                            work_status: 1,
                            work_status_date: item.start_date
                        };
                    const totalAcres = unit.toArea(getAreaOfPolygon(setOfLocation) * 0.000247105, 2);
                    const regionDetails = { ...item, totalAcres };
                    delete regionDetails.shapes;
                    fieldListById[e.geo_shape_uuid] = { ...e, regionDetails, lastWorkStatus };
                });
            });
            state = {
                ...state,
                fieldListById: {
                    isRequesting: false,
                    payload: fieldListById
                }

            };
            break;
        }
        case FIELD_LIST_REQUEST_ID: {
            state = {
                ...state,
                requestIds: [...state.requestIds, action.requestId]
            };
            break;
        }
        case GET_GEO_WORKED_ACRES_REQUEST: {
            state = {
                ...state,
                workedAcresById: {
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case GET_GEO_WORKED_ACRES: {
            const { payload, range } = action;
            const unit = Unit.getInstance();
            const fieldListById = state.fieldListById.payload;
            let workedAcresById = {};
            payload && payload.data && Array.isArray(payload.data) && payload.data.forEach(item => {
                const filteredIds = Object.keys(fieldListById).filter(id => fieldListById[id].regionDetails.geo_region_uuid === item.geo_region_uuid);
                const { workedAcres, isLinearAcres } = getWorkedAcres(item, range);

                for (const shapeId of filteredIds) {
                    const totalAcres = fieldListById[shapeId].regionDetails.totalAcres;
                    const percentage = (workedAcres > 0 && totalAcres > 0) ?
                        unit.toFixedOf((workedAcres / totalAcres) * 100, 2) : 0;

                    workedAcresById[shapeId] = {
                        workedAcres,
                        isLinearAcres,
                        percentage,
                        startDate: null,
                        endDate: null
                    };
                }
            });
            state = {
                ...state,
                workedAcresById: {
                    isRequesting: false,
                    payload: workedAcresById
                }
            };
            break;
        }
        case UPDATE_FIELD_WORK_STATUS_SUCCESS: {
            const workStatus = action.payload.work_status;
            const fieldListById = state.fieldListById.payload;
            workStatus.forEach(e => {
                let { geo_shape_uuid, work_status, work_status_date } = e;
                if (fieldListById[geo_shape_uuid]) {
                    const fieldItem = fieldListById[geo_shape_uuid];
                    fieldListById[geo_shape_uuid] = {
                        ...fieldItem,
                        lastWorkStatus: { ...fieldItem.lastWorkStatus, work_status, work_status_date }
                    };
                };
            });
            state = produce(state, s => {
                s.fieldListById.isRequesting = false;
                s.fieldListById.payload = { ...fieldListById };
            });
            break;
        }
        case GET_GEO_CROP_LIST:
            state = {
                ...state,
                cropList: [...action.payload],
            };
            break;
        case GEO_REGION_WORKED_DATE_REQUEST:
            state = produce(state, s => {
                s.workedDate.isRequesting = true;
                s.workedDate.payload = {
                    ...s.workedDate.payload
                };
            });
            break;
        case GEO_REGION_WORKED_DATE:
            state = produce(state, s => {
                s.workedDate.isRequesting = false;
                s.workedDate.payload = {
                    ...s.workedDate.payload,
                    ...action.payload.geo_region_uuid && {
                        [action.payload.geo_region_uuid]: action.payload.date
                    }
                };
            });
            break;
        case GEO_REGION_WORKED_EG_REQUEST:
            state = produce(state, s => {
                s.workedEG.isRequesting = true;
                s.workedEG.payload = [];
            });
            break;
        case GEO_REGION_WORKED_EG:
            state = produce(state, s => {
                s.workedEG.isRequesting = false;
                s.workedEG.payload = action.payload ? action.payload : [];
            });
            break;
        case TARE_LOAD_CAPACITY:
            const type = action.payload.type;
            const { data, shapeId } = action.payload;
            if (!data) {
                state = produce(state, s => {
                    s.totalTareCapacity = {}
                })
            }
            else if (type === "fullList") {
                const fullListObj = {
                    totalYearTareTotal: data.load.total_capacity,
                    totalYearLoadCount: data.load.total_count
                }
                state = produce(state, s => {
                    s.totalTareCapacity[shapeId] = { ...state.totalTareCapacity[shapeId], ...fullListObj }
                })
            } else {
                const dateWiseObj = {
                    selectedDateTareTotal: data.load.total_capacity,
                    totalDateWiseLoadCount: data.load.total_count
                }
                state = produce(state, s => {
                    s.totalTareCapacity[shapeId] = { ...state.totalTareCapacity[shapeId], ...dateWiseObj }
                })
            }
            break;
        case GEO_CONFIG:
            const { farm_config } = action.payload;
            if (!farm_config) {
                state = produce(state, s => {
                    s.geo_config = {}
                })
            } else {
                state = produce(state, s => { s.geo_config = farm_config })
            }
            break;
        default:
            break;
    }
    return state;
};
